export default __webpack_public_path__ + "static/media/SkybagsCardiff1.abb76466.jpg";